import { z } from "zod";

// Define the schema using Zod (aligned with register payload expectations)
const phoneregex =
	/^\+?(\d{1,3})?[\s\.\-]?(\(?\d{1,4}\)?)[\s\.\-]?(\d{1,4})[\s\.\-]?(\d{1,4})[\s\.\-]?(\d{1,4})?$/;

const UserValidationSchema = z.object({
	name: z.string().trim().min(1, "Name is required").max(510),
	email: z.string().email("Invalid email format"),
	password: z
		.string()
		.min(8, "Password must be at least 8 characters long")
		.max(25, "Password must be at most 25 characters long")
		.refine((val) => /[A-Za-z]/.test(val), {
			message: "Password must contain at least one letter",
		})
		.refine((val) => /\d/.test(val), {
			message: "Password must contain at least one number",
		}),
	phoneNumber: z
		.string()
		.refine((val) => phoneregex.test(val), {
			message: "Invalid phone number format",
		})
		.optional(),
	role: z.string().min(1).max(255).optional(),
	active: z.boolean().optional(),
	referralSource: z.string().optional(),
});

export default UserValidationSchema;
